import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NavController, ModalController } from '@ionic/angular';
import { AbstractPage } from '../AbstractPage';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';

/**
 * Il form per inviare una notifica
 */

@Component({
    selector: 'app-invio-notifica',
    templateUrl: './invio-notifica.page.html',
    styleUrls: ['./invio-notifica.page.scss'],
    standalone: false
})
export class InvioNotificaPage extends AbstractPage implements OnInit {
  form: FormGroup;
  bloccaForm: false;
  constructor(
    public navCtrl: NavController,
    public router: Router,
    public route: ActivatedRoute,
    public modalCtrl: ModalController,
    private formBuilder: FormBuilder
  ) {
    super(navCtrl, router);
    this.form = this.formBuilder.group({
      testo: [
        '',
        Validators.compose([
          Validators.minLength(3),
          Validators.maxLength(500),
          Validators.required
        ])
      ]
    });
  }

  ngOnInit() {
    console.log('ngOnInit InvioNotificaPage');
  }
  conferma() {
    this.modalCtrl.dismiss(this.form.value);
  }
  annulla() {
    this.modalCtrl.dismiss();
  }
}
